import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {breakpoints, spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  button: css`
    height: ${spacing(25)};
    ${cssTheme.components.buttons.outline.border.token}: 1px solid ${cssTheme.colors.coldGray[250]};
    ${cssTheme.fonts.sizes.body2.token}: 18px;

    ${breakpoints.down('sm')} {
      height: auto;
      text-align: start;
      ${cssTheme.components.buttons.outline.border.token}: none;
      ${cssTheme.components.slots.size.m.token}: ${spacing(8)};
      ${cssTheme.fonts.sizes.body2.token}: 16px;
    }
  `,
  container: css`
    ${breakpoints.down('sm')} {
      flex-wrap: nowrap;
      align-items: center;
    }
  `,
  desktopIcon: css`
    font-size: ${spacing(5)};

    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  mobileIcon: css`
    font-size: ${spacing(3.5)};
    margin-inline-end: ${spacing(2)} !important; // 😔 кривые стили gwc

    ${breakpoints.up('md')} {
      display: none;
    }
  `,
  cornerRightIcon: css`
    transform: rotate(-90deg);
    margin-inline-start: auto !important; // 😔 кривые стили gwc

    ${breakpoints.up('md')} {
      display: none;
    }
  `,
}
